import React, { useContext, useEffect, useState } from "react";
import {
  doc,
  getDoc,
  onSnapshot,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { AuthContext } from "../../context/AuthContext";
import { db } from "../../firebase";
import { ChatContext } from "../../context/ChatContext";
import parse from "html-react-parser";

export default function Chats() {
  const [chats, setChats] = useState([]);
  const [err, setErr] = useState(false);
  const [groupchats, setGroupchats] = useState([]);
  const { currentUser, currentUserData } = useContext(AuthContext);
  const { dispatch } = useContext(ChatContext);
  useEffect(() => {
    const getChats = () => {
      const unsub = onSnapshot(doc(db, "userChats", currentUser.uid), (doc) => {
        doc.data() && setChats(Object.entries(doc.data()));
      });
      return () => {
        unsub();
      };
    };

    currentUser.uid && getChats();
  }, [currentUser.uid]);

  const handleSelect = async (data) => {
    console.log(data);
    let isGroup = data.groupInfo !== undefined;
    let recieverData = isGroup ? data.groupInfo : data.userInfo;
    let tempCI = currentUser?.uid;
    const chatId = isGroup
      ? data.groupInfo.uid
      : tempCI > data.userInfo.uid
      ? tempCI + data.userInfo.uid
      : data.userInfo.uid + tempCI;
    let payload = { isGroup, chatId };
    console.log(data);
    if (isGroup) {
      payload = { ...payload, ...data.groupInfo };
    } else {
      payload = { ...payload, ...data.userInfo };
    }
    dispatch({
      type: "CHANGE_USER",
      payload,
    });
    try {
      const res = await getDoc(doc(db, "chats", chatId));

      if (!res.exists()) {
        //create chat in chats collection
        await setDoc(doc(db, "chats", chatId), { messages: [] });
        await updateDoc(doc(db, "userChats", currentUser.uid), {
          [chatId + ".userInfo"]: {
            uid: recieverData.uid,
            displayName: recieverData.displayName,
            photoURL: recieverData.photoURL,
          },
          [chatId + ".date"]: serverTimestamp(),
        });

        await updateDoc(doc(db, "userChats", recieverData.uid), {
          [chatId + ".userInfo"]: {
            uid: currentUser.uid,
            displayName: currentUser.displayName,
            photoURL: currentUser.photoURL,
          },
          [chatId + ".date"]: serverTimestamp(),
        });
      }
    } catch (error) {
      setErr(true);
    }
  };

  useEffect(() => {
   console.log(chats);
  }, [chats])
  
  return (
    <div className="chats">
      {chats &&
        chats
          ?.sort((a, b) => b[1].date - a[1].date)
          .map((chat) => {
            return (
              <div
                className="userChat"
                key={chat[0]}
                onClick={() => handleSelect(chat[1])}
              >
                <img
                  src={
                    chat[1].groupInfo
                      ? chat[1].groupInfo?.photoURL ||
                        "https://i.ibb.co/KWvYHpX/360-F-64676383-Ldbmhi-NM6-Ypzb3-FM4-PPu-FP9r-He7ri8-Ju.jpg"
                      : chat[1].userInfo?.photoURL ||
                        "https://i.ibb.co/KWvYHpX/360-F-64676383-Ldbmhi-NM6-Ypzb3-FM4-PPu-FP9r-He7ri8-Ju.jpg"
                  }
                  alt="user"
                />
                <div className="userChatInfo">
                  <div className="username">
                    <div>
                      {chat[1].userInfo
                        ? chat[1].userInfo?.displayName
                        : chat[1].groupInfo?.displayName}
                    </div>
                    {chat[1].groupInfo && <span>(group)</span>}
                  </div>
                  <p className="lastMessage">
                    {chat[1].lastMessage?.text
                      ? parse(chat[1].lastMessage?.text)
                      : chat[1].lastMessage?.text==="" ? "image" : "Start chatting..."}
                  </p>
                </div>
              </div>
            );
          })}
    </div>
  );
}
